module.exports = __webpack_public_path__ + "static/media/login-register.87dda348.jpg";